import { Screen } from '@modules/shared/services/window.service';

import { MediaSetting } from '../media-setting.interface';

export const StreamCardImageStyle: MediaSetting[] = [
  { screen: Screen.XXXS, key: '398_547_568', width: 568, height: 778, ratio: 0.73 },
  { screen: Screen.XS, key: '398_547_768', width: 768, height: 1052, ratio: 0.73 },
  { screen: Screen.SM, key: '311_170_1024', width: 1024, height: 563, ratio: 1.82 },
  { screen: Screen.MD, key: '311_170_1366', width: 1366, height: 751, ratio: 1.82 },
  { screen: Screen.LG, key: '299_136_1600', width: 1600, height: 731, ratio: 2.19 },
  { screen: Screen.XL, key: '299_136_1920', width: 1920, height: 877, ratio: 2.19 },
  { screen: Screen.XXL, key: '299_136_2540', width: 2540, height: 1160, ratio: 2.19 },
];

/** using slightly smaller image widths so we can re-use existing cuts */
export const StageMediaCardImageStyle: MediaSetting[] = [
  { screen: Screen.XXXS, key: '2_3_540', width: 568, height: 778, ratio: 0.66 },
  { screen: Screen.XS, key: '2_3_540', width: 768, height: 1052, ratio: 0.66 },
  { screen: Screen.SM, key: '3_2_1024', width: 1024, height: 563, ratio: 1.77 },
  { screen: Screen.MD, key: '3_2_1024', width: 1366, height: 751, ratio: 1.77 },
  { screen: Screen.LG, key: '2_1_1366', width: 1600, height: 731, ratio: 2 },
  { screen: Screen.XL, key: '2_1_1366', width: 1920, height: 877, ratio: 2 },
];
